import { Component } from '@angular/core';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MobileUiService } from './shared/services/mobile-ui.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public breakpointObserver: BreakpointObserver, private mobileUiService: MobileUiService) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        this.mobileUiService.isMobile.next(state.matches);
      });
  }
}
